<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link  class="text-inexorange hover:text-white" :href="route('organizations')">Comercio</inertia-link>
      <span class="text-white font-medium">/   {{ form.nameCommerce }}</span>
    </h1>
    <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore">
      This organization has been deleted.
    </trashed-message>
    <button v-if="$page.props.auth.user.rol !='Comercio'" style="color: white;" class="px-8 py-3 btn-indigoOrange" @click="showModal"">
        <span>+</span>
        <span class="hidden md:inline">Wallets</span>
    </button>
      <inertia-link  style="color: white;" class="px-8 py-3 btn-indigoOrange" :href="route('organizationsImages.edit',form.id)">
        <span>Imagenes</span>
        <span class="hidden md:inline">Generales
        </span>
      </inertia-link>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ruc" :error="form.errors.ruc" class="pr-6 pb-8 w-full lg:w-1/3" label="RUC Comercio" required/>
          <text-input v-model="form.nameCommerce" :error="form.errors.nameCommerce" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombre Comercio" required/>
          <text-input v-model="form.nameRepresentation" :error="form.errors.nameRepresentation" class="pr-6 pb-8 w-full lg:w-1/3" label="Representante" required/>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-2/6" label="Email" required/>
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-2/6" label="Teléfono" />
          <text-input v-model="form.website" :error="form.errors.website" class="pr-6 pb-8 w-full lg:w-2/6" label="Sitio Web" />
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-4/6" label="Dirección" required/>
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-2/6" label="Ciudad" required/>
          <text-area-input v-if="$page.props.auth.user.rol != 'Comercio'" v-model="form.publicKey" :error="form.errors.publicKey" class="pr-6 pb-8 w-full lg:w-2/2" label="Public Key" />
          <text-area-input v-if="$page.props.auth.user.rol != 'Comercio'" v-model="form.privateKey" :error="form.errors.privateKey" class="pr-6 pb-8 w-full lg:w-2/2" label="Private Key" />    
        </div>
               <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex items-center">

          <button v-if="!organization.deleted_at && $page.props.auth.user.rol != 'Comercio'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">BORRAR COMERCIO</button>
          <button  v-if="$page.props.auth.user.rol != 'Comercio'" class="px-8 py-4 btn-indigoOrange ml-auto" tabindex="-1" type="button" @click="validar">Validar Claves</button>
          <loading-button :loading="form.processing" style="color: white;" class="px-8 py-4 btn-indigoOrange ml-auto" type="submit">ACTUALIZAR COMERCIO</loading-button>
        </div>
      </form>
    </div>
    <!--Modal Wallets-->
     <Modal
  v-show="isModalVisible"
  @close="closeModal"
>
  <template v-slot:header>
   <!-- This is a new modal header.-->
  </template>

  <template v-slot:body>
    <div class="grid grid-cols-2 gap-4">
 <div class="bg-black rounded-md shadow overflow-hidden max-w-3xl">
    <form @submit.prevent="updateWallet">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form2.wallet_id" :error="form.errors.wallet_id" class="pr-6 pb-8 w-full lg:w-3/6" label="Wallet ID" required/>
          <text-input v-model="form2.passphrase" :error="form.errors.passphrase" class="pr-6 pb-8 w-full lg:w-3/6" label="Passphrase" required/>
        </div>
         <div class="px-8 py-4 bg-transparent flex justify-center items-center">

          <loading-button :loading="form.processing"  style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Agregar</loading-button>
        </div>
        </form>
    </div>
   
       <div class="container">
        <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold" style="background-color: black; color: white;">
               <th class="px-6 pt-6 pb-4">Id</th>
               <th class="px-6 pt-6 pb-4">Tipo</th>
          <th class="px-6 pt-6 pb-4">Wallet</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Estado</th>
        </tr>
        <tr v-for="w in was" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-4 py-3 flex items-center focus:text-indigo-500">
            {{ w.id }}
          </td>
           <td class="border-t">
            {{ w.type }}
          </td>
         <td class="border-t">
            {{ w.wallet_id }}
          </td>
         <td class="border-t">
            {{ w.status }}
          </td>
        
        </tr>

        </table>
       </div>
    </div>
    <br><br> <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
              <br><br>
             
  </template>

  <template v-slot:footer>
   <!-- This is a new modal footer.-->
  </template>
</Modal>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextAreaInput from '@/Shared/TextAreaInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import axios from "axios";
import Modal from '@/Shared/Modal.vue';

export default {
  metaInfo() {
    return { title: this.form.nameCommerce }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextAreaInput,
    Modal,
  },
  layout: Layout,
  props: {
    organization: Object,
    wallets: Array,
  },
  remember: 'form',
  data() {
    return {
      envia: false,
      isModalVisible: false,
      mensagge: '',
      was: [],
      form: this.$inertia.form({
        id: this.organization.id,
        ruc: this.organization.ruc,
        nameCommerce: this.organization.nameCommerce,
        nameRepresentation: this.organization.nameRepresentation,
        publicKey: this.organization.publicKey,
        privateKey: this.organization.privateKey,
        email: this.organization.email,
        phone: this.organization.phone,
        address: this.organization.address,
        city: this.organization.city,
        region: this.organization.region,
        country: this.organization.country,
        website: this.organization.website,
        wallet_id: this.organization.wallet_id,
        passphrase: this.organization.passphrase,
        cambiaclave: false,
      }),
      form2: this.$inertia.form({
        wallet_id: "",
        passphrase: "",
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('organizations.update', this.organization.id))
    },
      updateWallet() {

         axios.post('/wallets',{
          organization_id: this.organization.id,
          wallet_id: this.form2.wallet_id,
          passphrase: this.form2.passphrase,
         }).then(response => {
          if(response.data=='Duplicado')
         {
          this.mensagge='Wallet ya consta';

         }
         else{
          this.mensagge=response.data;

         }
      }).catch(error =>{
        this.mensagge='Error en las credenciales, revise porfavor!';
      }); 
        this.showModal();
    },
    destroy() {
      if (confirm('Estas seguro de bloquear el comercio?')) {
        this.$inertia.delete(this.route('organizations.destroy', this.organization.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(this.route('organizations.restore', this.organization.id))
      }
    },
     showModal() {
       axios.get(`/wallets/${this.organization.id}`,{
         }).then(response => {
          console.log(response.data);
          this.was=response.data;
      }); 
        this.isModalVisible = true;
        
      },
      closeModal() {
        this.isModalVisible = false;
      },
    async validar() {
      try {
        if(this.form.publicKey=="")
        {
          this.mensagge="Necesitamos una public key";
        }
        if(this.form.privateKey=="")
        {
          this.mensagge='Necesitamos una private key';
        }
        axios.post('https://napi.inexlatampay.com/api/public/auth',{
          publicKey: this.form.publicKey,
          privateKey: this.form.privateKey,
          }
          , {
   headers: {
    "Content-Type": "application/json"
        }
      }).then(res => {
       if(res.status==200)
       {
        console.log(res.data);
        this.mensagge='Claves válidas para su uso';
        this.form.cambiaclave=true;
       }
      }).catch(err => {
        this.mensagge='Revise claves son erroneas';

      });
      } catch (error) {
        console.log(error);
      }
    },
    
  },
}
</script>
